import React from 'react';

function Solution() {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row">
              <div className="col-lg-5">
                <h4 className="mb-50">02 . Before and After Gallery</h4>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solution;
